import React from "react";

import { useTranslation } from "utils";

import { Button, Flex, Icon, LazyLoadImage, Typography } from "components";

const steps = [
  {
    titleKey: "stepOneTitle",
    iconName: "klim/ruler-measure",
  },
  {
    titleKey: "stepTwoTitle",
    iconName: "klim/planting-plant",
  },
  {
    titleKey: "stepThreeTitle",
    iconName: "tabler/trending-up",
  },
];

export default function WelcomeScreen({ onFormStart }: { onFormStart: () => void }) {
  const { t } = useTranslation("digitalAgronomist");

  return (
    <section className="container content welcome-screen-container" data-testid="digital-agronomist-welcome-screen-container">
      <Flex align="center" justify="center" gap="4rem">
        <LazyLoadImage
          wrapperClassName="step-image-wrapper"
          alt="side-crop-image"
          src="/images/digital-agronomist/digital-agronomist-welcome-screen.jpg"
          width={420}
          height={420}
        />
        <div className="text-container">
          <Typography variant="h1" className="margin-bottom-200">
            {t("onboarding.title")}
          </Typography>
          <Flex align="flex-start" justify="center" vertical gap="1.5rem">
            {steps.map((step, i) => (
              <Flex key={i} className="step-container" align="center" justify="flex-start" gap="1rem">
                <Icon iconName={step.iconName} />
                <Typography variant="h6">{t(`welcomeScreen.${step.titleKey}`)}</Typography>
              </Flex>
            ))}
          </Flex>
          <div className="margin-top-400" style={{ width: "100%" }}>
            <Button type="primary" dataTestId="welcome-screen-cta-button" onClick={onFormStart}>
              {t("welcomeScreen.cta")}
            </Button>
          </div>
        </div>
      </Flex>
    </section>
  );
}
